function Kickflip() {
  return (
    <div className="dice-face face--kickflip">
      <span>KICK</span>
      <span>FLIP</span>
    </div>
  );
}

export default Kickflip;
